import { render, staticRenderFns } from "./topicRecommand.vue?vue&type=template&id=59b5f1d7&scoped=true"
import script from "./topicRecommand.vue?vue&type=script&lang=js"
export * from "./topicRecommand.vue?vue&type=script&lang=js"
import style0 from "./topicRecommand.vue?vue&type=style&index=0&id=59b5f1d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b5f1d7",
  null
  
)

export default component.exports